import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography,
} from "@mui/material";
import AllocationManager from "./AllocationManager";
import { useMe } from "../MeContext";
import { useFullScreenDialog } from "../useFullScreenDialog";

/**
 * Every allocation not yet Returned, across every event — "what kit hasn't come
 * back?". The other views each sit inside one item, person or event; this one fixes
 * nothing, so it shows the Event, Item and Person columns, in the server's order
 * (most recent event first). Nothing is added from here, since an allocation needs a
 * person and an event to be for; a row marked returned simply drops off the list.
 *
 * Props:
 *  - open:    boolean
 *  - onClose: () => void
 */
export default function OutstandingAllocationsDialog({ open, onClose }) {
  const { can } = useMe();
  const fullScreen = useFullScreenDialog();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" fullScreen={fullScreen}>
      <DialogTitle>Allocations not yet returned</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1}>
          <Typography variant="caption" color="text.secondary">
            Kit still out to someone, on any event — everything Assigned or Given.
          </Typography>
          <AllocationManager
            outstanding={open}
            exportTitle="not returned"
            showReturn
            canAdd={false}
            canEdit={can("InventoryItems.edit")}
            canDelete={can("InventoryItems.delete")}
            canExport={can("InventoryItems.export")} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
